import {
  Divider,
  Grid,
  Typography,
  Box,
  TextField,
  Button,
  InputAdornment,
  IconButton,
} from "@mui/material";
import React from "react";
import StarBorderPurple500Icon from "@mui/icons-material/StarBorderPurple500";
import siva from "../assets/siva.png";
import ganesha from "../assets/ganesha.png";
import DateRangeIcon from "@mui/icons-material/DateRange";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { Navigate, useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const socialIcons = [
    {
      icon: <FacebookIcon />,
      color: "#3b5998",
      hover: "#2d4373",
      label: "Facebook",
    },
    {
      icon: <InstagramIcon />,
      color: "#E1306C",
      hover: "#c12b5c",
      label: "Instagram",
    },
    {
      icon: <TwitterIcon />,
      color: "#1DA1F2",
      hover: "#0d95e8",
      label: "Twitter",
    },
    {
      icon: <YouTubeIcon />,
      color: "#FF0000",
      hover: "#cc0000",
      label: "YouTube",
    },
  ];

  return (
    <>
      <Grid
        container
        spacing={4}
        sx={{ p: { xs: 3, md: 10 }, bgcolor: "#ffc20f" }}
      >
        <Grid
          size={{ xs: 12, md: 3 }}
          sx={{ display: "flex", flexDirection: "column" }}
        >
          <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            <Divider
              orientation="vertical"
              flexItem
              sx={{ bgcolor: "#6d1675", width: 2, height: 20 }}
            />
            <Typography
              sx={{ fontSize: 16, fontWeight: "bold", color: "#fff" }}
            >
              About Puja Services
            </Typography>
          </Box>
          <Typography sx={{ mt: 2, color: "#fff" }}>
            Puja Services is the leading digital platform for all Hindu
            devotional needs and spiritual services.
          </Typography>
          <Box sx={{ display: "flex", gap: 1, mt: 4 }}>
            {socialIcons.map((item, i) => (
              <IconButton
                key={i}
                sx={{
                  bgcolor: item.color,
                  color: "#fff",
                  "&:hover": { bgcolor: item.hover },
                  borderRadius: "50%",
                }}
                aria-label={item.label}
              >
                {item.icon}
              </IconButton>
            ))}
          </Box>
        </Grid>

        <Grid
          size={{ xs: 12, md: 3 }}
          sx={{ display: "flex", flexDirection: "column" }}
        >
          <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            <Divider
              orientation="vertical"
              flexItem
              sx={{ bgcolor: "#6d1675", width: 2, height: 20 }}
            />
            <Typography
              sx={{ fontSize: 16, fontWeight: "bold", color: "#fff" }}
            >
              Quick Links
            </Typography>
          </Box>
          <Box sx={{ mt: 2 }}>
            {[
              "Online Puja Booking",
              "Temple Puja Booking",
              "Priest Booking",
              "Vedic Ashirvaad",
              "Contact Us",
            ].map((link, index) => (
              <Box
                key={index}
                sx={{ display: "flex", alignItems: "center", mb: 1 }}
              >
                <StarBorderPurple500Icon
                  sx={{ fontSize: 14, color: "#6d1675", mr: 1 }}
                />
                <Typography sx={{ color: "#fff" }}>{link}</Typography>
              </Box>
            ))}
          </Box>
        </Grid>

        <Grid
          size={{ xs: 12, md: 3 }}
          sx={{ display: "flex", flexDirection: "column" }}
        >
          <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            <Divider
              orientation="vertical"
              flexItem
              sx={{ bgcolor: "#6d1675", width: 2, height: 20 }}
            />
            <Typography
              sx={{ fontSize: 16, fontWeight: "bold", color: "#fff" }}
            >
              Pujas
            </Typography>
          </Box>

          <Box sx={{ mt: 2, display: "flex", gap: 2 }}>
            <img
              src={ganesha}
              alt="Ganapathi"
              style={{ width: 70, height: 70 }}
            />
            <Box sx={{ mt: 1 }}>
              <Typography sx={{ fontWeight: "bold", color: "#fff" }}>
                Ganapathi Homa
              </Typography>
              <Typography
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  color: "#6d1675",
                  fontSize: 14,
                }}
              >
                <DateRangeIcon sx={{ fontSize: 16 }} /> Every Purnima
              </Typography>
            </Box>
          </Box>

          <Divider sx={{ my: 2, bgcolor: "#6d1675" }} />

          <Box sx={{ display: "flex", gap: 2 }}>
            <img src={siva} alt="Shiva" style={{ width: 70, height: 70 }} />
            <Box sx={{ mt: 1 }}>
              <Typography sx={{ fontWeight: "bold", color: "#fff" }}>
                Shiva
              </Typography>
              <Typography
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  color: "#6d1675",
                  fontSize: 14,
                }}
              >
                <DateRangeIcon sx={{ fontSize: 16 }} /> Every Purnima
              </Typography>
            </Box>
          </Box>
        </Grid>

        <Grid
          size={{ xs: 12, md: 3 }}
          sx={{ display: "flex", flexDirection: "column" }}
        >
          <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            <Divider
              orientation="vertical"
              flexItem
              sx={{ bgcolor: "#6d1675", width: 2, height: 20 }}
            />
            <Typography
              sx={{ fontSize: 16, fontWeight: "bold", color: "#fff" }}
            >
              Subscribe for Divine Updates!
            </Typography>
          </Box>

          <Typography sx={{ mt: 2, color: "#fff" }}>
            Stay informed about upcoming pujas, spiritual insights, and special
            blessings.
          </Typography>

          <Box sx={{ mt: 4 }}>
            <TextField
              placeholder="Email Address"
              size="small"
              sx={{
                width: { xs: "100%", md: 250 },
                bgcolor: "#fff",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "4px",
                  paddingRight: 0,
                  "& fieldset": { borderColor: "#6d1675" },
                  "&:hover fieldset": { borderColor: "#6d1675" },
                  "&.Mui-focused fieldset": { borderColor: "#6d1675" },
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end" sx={{ p: 0 }}>
                    <Button
                      sx={{
                        bgcolor: "#6d1675",
                        color: "#fff",
                        height: "calc(100% + 2px)",
                        borderRadius: "0 4px 4px 0",
                        textTransform: "none",
                        fontWeight: "bold",
                        "&:hover": { bgcolor: "#6d1675" },
                        px: 2,
                      }}
                    >
                      Subscribe
                    </Button>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </Grid>
      </Grid>
      <Box
        sx={{
          bgcolor: "black",
          py: 1,
          px: { xs: 2, md: 8 },
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "space-between",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Typography sx={{ color: "#fff", fontWeight: "bold" }}>
          Copyrights © 2025 Puja Services
        </Typography>
        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
          <Typography
            onClick={() => navigate("/about-us")}
            sx={{ color: "#fff", fontWeight: "bold", cursor: "pointer" }}
          >
            About Us /
          </Typography>

          <Typography
            onClick={() => navigate("/privacy-policy")}
            sx={{ color: "#fff", fontWeight: "bold", cursor: "pointer" }}
          >
            Privacy /{" "}
          </Typography>
          <Typography
            onClick={() => navigate("/about-us")}
            sx={{ color: "#fff", fontWeight: "bold", cursor: "pointer" }}
          >
            {" "}
            Terms And Conditions /
          </Typography>
          <Typography
            onClick={() => navigate("/about-us")}
            sx={{ color: "#fff", fontWeight: "bold", cursor: "pointer" }}
          >
            {" "}
            Contact Us
          </Typography>
        </Box>
      </Box>
    </>
  );
};

export default Footer;

